import { ServiceStatus } from 'types/ServiceHealth';
import { handleRes } from 'utils';

export const getFileServiceHealth = (): Promise<{ status: ServiceStatus }> => {
  return fetch(`${window.FILE_BASE_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};

export const getUserServiceHealth = (): Promise<{ status: ServiceStatus }> => {
  return fetch(`${window.USER_BASE_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};

export const getVehicleServiceHealth = (): Promise<{
  status: ServiceStatus;
}> => {
  return fetch(`${window.VEHICLE_BASE_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};

export const getPropertyServiceHealth = (): Promise<{
  status: ServiceStatus;
}> => {
  return fetch(`${window.PROPERTY_BASE_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};

export const getJobServiceHealth = (): Promise<{ status: ServiceStatus }> => {
  return fetch(`${window.JOB_BASE_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};
export const getRevisionServiceHealth = (): Promise<{
  status: ServiceStatus;
}> => {
  return fetch(`${window.REVISION_BASE_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};

export const getPermitServiceHealth = (): Promise<{
  status: ServiceStatus;
}> => {
  return fetch(`${window.PERMIT_BASE_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};

export const getNotificationServiceHealth = (): Promise<{
  status: ServiceStatus;
}> => {
  return fetch(`${window.NOTIFICATION_BASE_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};

export const getAnalyticsServiceHealth = (): Promise<{
  status: ServiceStatus;
}> => {
  return fetch(`${window.TOPS_PPI_ADAPTER_BASE_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};

export const getRedirectServiceHealth = (): Promise<{
  status: ServiceStatus;
}> => {
  return fetch(`${window.REDIRECT_BASE_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};

export const getQRCodeServiceHealth = (): Promise<{
  status: ServiceStatus;
}> => {
  return fetch(`${window.QR_CODE_BASE_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};

export const getPaymentServiceHealth = (): Promise<{
  status: ServiceStatus;
}> => {
  return fetch(`${window.PAYMENT_BASE_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};

export const getFindMyCarServiceHealth = (): Promise<{
  status: ServiceStatus;
}> => {
  return fetch(`${window.FIND_MY_CAR_BASE_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};

export const getPermitClientServiceHealth = (): Promise<{
  status: ServiceStatus;
}> => {
  return fetch(`${window.PERMIT_CLIENT_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};

export const getTopsPPIAdapterServiceHealth = (): Promise<{
  status: ServiceStatus;
}> => {
  return fetch(`${window.TOPS_PPI_ADAPTER_BASE_URL}/healthz`)
    .then((res) => handleRes<{ status: ServiceStatus }>(res, 200))
    .catch(() => {
      return { status: ServiceStatus.FAIL };
    });
};
